import type { MemberAction } from '../types/content'

export const memberActions: MemberAction[] = [
  {
    id: 'licence',
    title: 'Renouveler ma licence 2027',
    description: 'Ouverture des renouvellements le 1er octobre. Attestation disponible immédiatement.',
    meta: 'Espace licencié',
  },
  {
    id: 'assurance',
    title: 'Assurer mon aéronef',
    description: 'Souscription et attestation RC aéronef, remorquage, passagers et structures.',
    meta: 'Contrat fédéral',
  },
  {
    id: 'immatriculation',
    title: 'Déclarer ou modifier une immatriculation',
    description: 'Carte d’identification, changement de propriétaire, fiche de pesée.',
    meta: 'Démarche DGAC',
  },
  {
    id: 'rex',
    title: 'Déposer un retour d’expérience',
    description: 'Anonyme, non punitif. Chaque REX alimente les analyses de la commission sécurité.',
    meta: 'Sécurité des vols',
  },
]
